'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FullScreenErrorModal = require('../../../components/modal/FullScreenErrorModal');

var _FullScreenErrorModal2 = _interopRequireDefault(_FullScreenErrorModal);

var _ModalActionsList = require('../../../components/modal/ModalActionsList');

var _ModalActionsList2 = _interopRequireDefault(_ModalActionsList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
// Lib
var ChangePasswordExpiredModal = function ChangePasswordExpiredModal(_ref) {
    var navigateToLogin = _ref.navigateToLogin,
        navigateToForgotPassword = _ref.navigateToForgotPassword;

    var actions = [{ text: 'Reset your password again', func: navigateToForgotPassword }];

    return _react2.default.createElement(
        _FullScreenErrorModal2.default,
        null,
        _react2.default.createElement(
            'div',
            { className: 'heading' },
            _react2.default.createElement(
                'h2',
                null,
                'This code has expired.'
            )
        ),
        _react2.default.createElement(
            'p',
            null,
            'You only have one hour to reset your password after you receive the reset password email.'
        ),
        _react2.default.createElement(_ModalActionsList2.default, { actions: actions }),
        _react2.default.createElement(
            'div',
            { className: 'section secondary' },
            _react2.default.createElement(
                'div',
                { className: 'return-to-login' },
                'Go back to the \xA0',
                _react2.default.createElement(
                    'a',
                    { href: '/login', onClick: navigateToLogin },
                    'Log in screen'
                )
            )
        )
    );
};

ChangePasswordExpiredModal.propTypes = {
    navigateToLogin: _propTypes2.default.func.isRequired,
    navigateToForgotPassword: _propTypes2.default.func.isRequired
};

exports.default = ChangePasswordExpiredModal;


//////////////////
// WEBPACK FOOTER
// ./src/client/auth/modals/changePassword/ChangePasswordExpiredModal.js
// module id = 1671
// module chunks = 0